import axios from 'axios'

export type User = {
  _id: string
  name: string
  email: string
  roles: string[]
  companyRef?: string
  blocked?: boolean
  /** Assuming DateTime is represented as an ISO string in the API response */
  expiryDate?: string
}

/** A user being created: the backend assigns `_id`, never send an empty one. */
export type NewUser = Omit<User, '_id'> & { _id?: string }

export const UsersService = {
  async getAll(): Promise<User[]> {
    const { data } = await axios.get<User[]>('/api/users')
    return data
  },

  async deleteUser(id: string): Promise<void> {
    await axios.delete(`/api/users/${id}`)
  },

  async addUser(user: Omit<User, '_id'>): Promise<User> {
    const { data } = await axios.post<User>('/api/users', user)
    return data
  },

  async updateUser(user: User): Promise<User> {
    const { data } = await axios.put<User>(`/api/users/${user._id}`, user)
    return data
  },

  async resetPassword(id: string): Promise<void> {
    await axios.post(`/api/users/resetPassword/${id}`)
  },

  async getUserById(id: string): Promise<User | null> {
    const { data } = await axios.get<User | null>(`/api/users/${id}`)
    return data
  },
}
